import {useContext} from 'react'
import {Navigate} from 'react-router-dom'
import AuthContext from '../contexts/AuthContext'

interface IProps {
    element: any
    roleRequired?: any
}

const PrivateRoute = ({element, roleRequired}: IProps) => {
    const {isLoggedIn, isAdmin} = useContext(AuthContext)

    if (!isLoggedIn) {
        return <Navigate to="/auth/login"/>;
    }

    if (roleRequired && roleRequired === "admin" && !isAdmin) {
        return <Navigate to="/"/>;
    }

    return element;
};

export default PrivateRoute;
